(function ($) {
  const tabsToSelect = function () {
    const $tabButtonItem = $('#tabs li');
    const $tabSelect = $('#tab-select');
    const $tabContents = $('.tab-pane');
    const activeClass = 'is-active';

    $tabButtonItem.find('a').first().addClass(activeClass);
    $tabContents.not(':first').hide();

    $tabButtonItem.find('a').on('click', function (e) {
      // Hijack Bootstrap's tabs for consistency
      const target = $(this).attr('href');

      $tabButtonItem.find('a').removeClass(activeClass);
      $(this).parent().addClass(activeClass);
      $(this).addClass(activeClass);
      $tabSelect.val(target);
      $tabContents.hide().removeClass('active');
      $(target).show().addClass('active');
      e.stopPropagation();
      e.preventDefault();
    });

    $tabSelect.on('change', function () {
      // Spoof tab behavior when option is selected
      const target = $(this).val();
      const targetSelectNum = $(this).prop('selectedIndex');

      $tabButtonItem.find('a').removeClass(activeClass);
      $('.nav-item .nav-link').removeClass(activeClass);
      $tabButtonItem.eq(targetSelectNum).find('a').addClass(activeClass);
      $tabContents.hide();
      $(target).show();
    });
  };

  //If the URL has an anchor, select the associated tab
  const selectUrlTab = function () {
    if (window.location.hash) {
      var hashText = window.location.hash.replace('#', '');
      var anchoredTab = $("#" + hashText);
      if (anchoredTab.length > 0) {
        $(".nav-item .nav-link").removeClass("is-active");
        $("#tab" + hashText).addClass("is-active");

        $("#tab-select").val("#" + hashText);
        $(".tab-pane").hide().removeClass("active");
        anchoredTab.show().addClass("active");
      }
    }
  };

  const init = function () {
    if ($('#resourcesContent').length) {
      tabsToSelect();
      selectUrlTab();
    }
  };

  $(init);
}(jQuery));
